import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AspRoles, AspPartsAdminRoles } from '../shared/services/util.service';
import { aspAuthenticationGuardService } from '../shared/guards/auth.guard';
import { ProtectRoute } from '../shared/guards/protect-route.guard';
import { PartsScheduleModule } from 'src/app/modules/parts/parts-schedule/parts-schedule.module';
import { PartsGeneralSettingsModule } from 'src/app/modules/parts/parts-general-settings/parts-general-settings.module';
import { PartsPersonnelModule } from 'src/app/modules/parts/parts-personnel/parts-personnel.module';
import { DealershipHolidaysModule } from '../dealership-holidays/dealership-holidays.module';

const routes: Routes = [
  {
    path: '',
    canActivate: [ProtectRoute],
    children: [
      {
        path: '',
        redirectTo: 'scheduledashboard',
        pathMatch: 'full'
      },
      {
        path: 'scheduledashboard',
        loadChildren: () => PartsScheduleModule
      },
      {
        path: 'settings',
        loadChildren: () => PartsGeneralSettingsModule,
        data: { roles: [...AspRoles, ...AspPartsAdminRoles] },
        canActivateChild: [aspAuthenticationGuardService]
      },
      {
        path: 'manageadvisors',
        loadChildren: () => PartsPersonnelModule,
        data: { roles: [...AspRoles, ...AspPartsAdminRoles] },
        canActivateChild: [aspAuthenticationGuardService]
      },
      {
        path: 'manageholidays',
        loadChildren: () => DealershipHolidaysModule,
        data: { roles: [...AspRoles, ...AspPartsAdminRoles] },
        canActivateChild: [aspAuthenticationGuardService]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartsRoutingModule { }